<div id="comparativechartdiv" style="width: 100%; height: 450px"></div>